import { Icon, IconKey } from '@/shared/components/icon';
import { useAIChat } from '../context';
import { ConversationPanel } from './conversation-panel';

export function AIChatDrawer() {
  const { activeConversationId, isDraft, closeChat, startNewConversation, openChat } = useAIChat();

  // flex-1 overflow-auto p-6 bg-card rounded-2xl shadow-xl relative z-10 my-3 transition-all duration-300
  return (
    <div className='w-1/4 border-l border-border/50 flex flex-col overflow-hidden bg-card rounded-l-2xl shadow-xl my-3'>
      {/* Header */}
      <div className='flex items-center justify-between px-4 py-3 border-b border-border/50'>
        <div className='flex items-center gap-2'>
          <Icon icon={IconKey.Sparkles} size={20} className='text-accent' />
          <h2 className='text-sm font-semibold'>Tally AI</h2>
        </div>
        <div className='flex items-center gap-1'>
          {(activeConversationId || isDraft) && (
            <button
              onClick={() => openChat()}
              className='p-1.5 rounded-md hover:bg-secondary/30 transition-colors hover:cursor-pointer'
              title='Back to conversations'
            >
              <Icon icon={IconKey.ChevronLeft} size={16} className='text-text/50' />
            </button>
          )}
          <button
            onClick={startNewConversation}
            className='p-1.5 rounded-md hover:bg-secondary/30 transition-colors hover:cursor-pointer'
            title='New conversation'
          >
            <Icon icon={IconKey.Plus} size={16} className='text-text/50' />
          </button>
          <button
            onClick={closeChat}
            className='p-1.5 rounded-md hover:bg-secondary/30 transition-colors hover:cursor-pointer'
            title='Close'
          >
            <Icon icon={IconKey.X} size={16} className='text-text/50' />
          </button>
        </div>
      </div>

      {/* Content */}
      {activeConversationId || isDraft ? (
        <ConversationPanel conversationId={activeConversationId} />
      ) : (
        <ConversationListPanel />
      )}
    </div>
  );
}

// Re-export from separate file for the list
import { ConversationListPanel } from './conversation-list-panel';
